import http from "./apiServices"

export const getResources = ({ limit, offset }) => {
  return http.get("resources", { params: { limit, offset } })
}

export const postResources = (file) => {
  return http.post("resources", file, { headers: { "Content-Type": "multipart/form-data" } })
}
